import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import useAuth from "hooks/useAuth";

const PaymentSettingGuard = ({ children }) => {
  const { user, isLoggedIn } = useAuth();

  if (isLoggedIn && user && user.canViewPaymentSetting === false) {
    return <Navigate to="/dashboard/default" replace />;
  }

  return children;
};

PaymentSettingGuard.propTypes = {
  children: PropTypes.node,
};

export default PaymentSettingGuard;
